import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {map, switchMap} from 'rxjs/operators';
import {Apollo} from 'apollo-angular';
import {NotificationService} from '../../../../services/notifications/notification.service';
import {Store} from '@ngrx/store';
import {AppState} from '../../../reducers';
import {ResponseCodesService} from '../../../../services/response-codes/response-codes.service';
import {AuthService} from '../../../../services/auth/auth.service';
import {getAllDistricts, loadDistricts} from './district.actions';
import {GET_ALL_DISTRICTS} from './district.graphql';
import {District} from './district.model';


@Injectable()
export class DistrictEffects {

    allDistricts$ = createEffect(() => this.actions$.pipe(
        ofType(getAllDistricts),
        switchMap((action) => {
            return this.apollo.query({
                query: GET_ALL_DISTRICTS,
                fetchPolicy: 'network-only'
            }).pipe(
                this.notificationService.catchError(),
                map(({data}: any) => {
                    if (data) {
                        this.store.dispatch(loadDistricts({districts: Object.values(data)[0] as District[]}));
                    }
                })
            );
        })
    ), {dispatch: false});

    constructor(
        private actions$: Actions,
        private apollo: Apollo,
        private notificationService: NotificationService,
        private store: Store<AppState>,
        private responseCodesService: ResponseCodesService,
        private auth: AuthService,
    ) {
    }

}
